// eslint-disable-next-line no-restricted-imports
import {
  CreateOrderDto_Input,
  MutationInput_OrderController_CreateOne_Input_OperationType,
} from 'api/generated/graphql';
import { CreateOrderParams } from 'api/types/params';
import { formatToISODate } from 'helpers';

import { parseUpdateOrderParams } from './parseUpdateOrderParams';

type ApiParams = Omit<CreateOrderDto_Input, 'ownerId' | 'ownerType' | 'token'>;

export const parseCreateOrderParams = (
  params: CreateOrderParams
): ApiParams => ({
  ...parseUpdateOrderParams(params),
  executionPeriodInBusinessDays: params.executionPeriodInBusinessDays,
  startDate: formatToISODate(params.startDate),

  operationType:
    MutationInput_OrderController_CreateOne_Input_OperationType[
      params.operationType
    ],
});
